import { setFocusOnField } from '@/core/core_components/form/form'
import { bindResetButtonModal } from '@/core/input_controls/button/button'
import { getLocalizedMessage, showMessageAlert } from '@/core/shared'
import { initDataInBoolean, initDataInTextInput } from '@/core/item_assistance/initializeComponentData'
import { getDataFromBoolean, getDataFromTextInput } from '@/core/item_assistance/receiveDataFromComponents'

export function CompanyRolesManager () {
	'use strict'

	this.action = undefined
	this.roleId = undefined
	this.companyId = undefined
	this.allPermissions = undefined
	this.rolePermissions = undefined
	this.postSaveAction = undefined
	this.postRemoveAction = undefined
	this.activeAttribute = undefined
	this.fields = undefined
	this.prefix = undefined
	this.userGroup = undefined
	this.global = undefined
	this.active = undefined
	this.roleIds = undefined

	this.setProperties = function (properties) {
		this.action = properties.action || 'create'
		this.roleId = properties.roleId || undefined
		this.companyId = properties.companyId
		this.allPermissions = properties.allPermissions
		this.rolePermissions = properties.rolePermissions
		this.userGroup = properties.userGroup || {}
		this.postSaveAction = properties.postSaveAction
		this.postRemoveAction = properties.postRemoveAction
		this.activeAttribute = properties.activeAttribute || undefined
		this.fields = properties.fields || ['name', 'description', 'permissions']
		this.prefix = properties.prefix || 'user-role_'
		this.global = properties.global || false
		this.active = properties.active || true
		this.roleIds = properties.roleIds || []
	}

	this.initPage = function () {
		this.createPermissionsCheckboxes()

		this.resetFields()
		if (this.action == 'edit') {
			this.setUserGroupInformation()
			this.setUserGroupPermissions()
			setFocusOnField(this.activeAttribute)
		}
		bindResetButtonModal()
	}

	this.openUserGroupModal = function (action) {
		var manager = this
		Swal.fire({
			title: getLocalizedMessage('company.roles'),
			html: '<div class="modal_item">\n' +
				'        <label for="user-role_name">' + getLocalizedMessage('name') + '</label>\n' +
				'        <br>\n' +
				'        <input id="user-role_name" class="textInput attribute-editor" type="text">\n' +
				'        <button class="button_reset fa fa-times"></button>\n' +
				'    </div>\n' +
				'    <div class="modal_item">\n' +
				'        <label for="user-role_description">' + getLocalizedMessage('description') + '</label>\n' +
				'        <br>\n' +
				'        <textarea id="user-role_description" class="textarea attribute-editor"></textarea>\n' +
				'        <button class="button_reset single-area-reset fa fa-times"></button>\n' +
				'    </div>\n' +
				'    <div class="modal_item">\n' +
				'        <div id="user-role_permissions" class="checkbox-block">\n' +
				'            <label for="user-role_permissions">' + getLocalizedMessage('permissions') + '</label>\n' +
				'            <br>\n' +
				'        </div>\n' +
				'    </div>',
			confirmButtonText: getLocalizedMessage('save'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowOutsideClick: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			},
			onRender: function () {
				manager.initPage()
			},
			preConfirm: function (inputValue) {
				var userGroupData = {}
				userGroupData['userGroupInformation'] = manager.getUserGroupInformation()
				userGroupData['userGroupPermissions'] = manager.getUserGroupPermissions()
				return userGroupData
			}
		}).then(function (result) {
			if (result.value) {
				manager.saveUserGroup(result.value.userGroupInformation, result.value.userGroupPermissions, action)
			}
		})
	}

	this.removeUserGroup = function () {
		var thisManager = this

		$.ajax({
			url: window.urlContext + 'role/deactivate',
			type: 'POST',
			data: { 'id': thisManager.roleId },

			success: function () {
				if (thisManager.postRemoveAction) {
					thisManager.postRemoveAction()
				}
				showMessageAlert(getLocalizedMessage('roles.removed'), 'success')
			},
			statusCode: {
				406: function () {
					showMessageAlert(getLocalizedMessage('error.roles.dependent.user'), 'danger')
				}
			},
			error: function () {
				showMessageAlert(getLocalizedMessage('error.removing'), 'danger')
			}
		})
	}

	this.removeUserGroupMultiple = function () {
		var thisManager = this

		$.ajax({
			url: window.urlContext + 'roles/deactivate',
			type: 'POST',
			data: { 'ids': JSON.stringify(thisManager.roleIds) },

			success: function () {
				if (thisManager.postRemoveAction) {
					thisManager.postRemoveAction()
				}
				showMessageAlert(getLocalizedMessage('roles.removed'), 'success')
			},
			statusCode: {
				406: function () {
					showMessageAlert(getLocalizedMessage('error.roles.dependent.user'), 'danger')
				}
			},
			error: function () {
				showMessageAlert(getLocalizedMessage('error.removing'), 'danger')
			}
		})
	}

	this.saveUserGroup = function (userGroupInformation, userGroupPermissions, action) {
		var userGroup = this,
			flag = false
		var url = (action === 'edit') ? 'role/update' : 'role/create'

		var newGroupId = 0
		$.ajax({
			url: window.urlContext + url,
			type: 'POST',
			data: JSON.stringify(userGroupInformation),
			contentType: 'application/json; charset=UTF-8',
			async: false,

			success: function (result) {
				flag = true
				newGroupId = result
			}
		})

		var roleId = (action === 'edit') ? this.roleId : newGroupId
		$.ajax({
			url: encodeURI(window.urlContext + 'role/permission/set?id=' + roleId + '&permissions=' + JSON.stringify(userGroupPermissions)),
			type: 'POST',
			async: false,

			success: function () {
				if (flag) {
					if (userGroup.postSaveAction) {
						userGroup.postSaveAction()
					}
					showMessageAlert(getLocalizedMessage('changes.saved'), 'success')
				}
			},
			error: function () {
				showMessageAlert(getLocalizedMessage('error.saving'), 'danger')
			}
		})
	}

	this.setUserGroupInformation = function () {
		var manager = this
		_.each(this.userGroup, function (value, key) {
			initDataInTextInput(manager.prefix + key, value)
		})
	}

	this.createPermissionsCheckboxes = function () {
		var userGroup = this
		if ($('#' + userGroup.prefix + 'permissions').find('.checkbox').length == 0) {
			_.each(this.allPermissions, function (permission) {
				$('#' + userGroup.prefix + 'permissions').children().last().after('<input type=\'checkbox\' id=\'' + permission.code + '\' data-id=' + permission.id + ' class=\'checkbox attribute-editor\'><label for=\'' + permission.code + '\'>' + permission.name + '</label><br>')
			})
		}
	}

	this.initRemoveUserGroupManager = function (item) {
		var manager = this
		Swal.fire({
			title: getLocalizedMessage('roles.remove.confirmation'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			},
			onRender: function () {
				manager.setProperties({
					global: true,
					action: 'remove',
					roleId: item.id,
					postRemoveAction: function () {
						table.initTable()
						table.selectedItemsManager.deleteRowMarkById(item.id)
					}
				})
			}
		}).then(function (result) {
			if (result.value) {
				manager.removeUserGroup()
			}
		})
	}

	this.initRemoveGroupsManager = function (ids) {
		var manager = this
		Swal.fire({
			title: getLocalizedMessage('roles.remove.confirmation'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			},
			onRender: function () {
				manager.setProperties({
					global: true,
					action: 'remove',
					roleIds: ids,
					postRemoveAction: function () {
						table.initTable()
						table.selectedItemsManager.clearSelections(table)
					}
				})
			}
		}).then(function (result) {
			if (result.value) {
				manager.removeUserGroupMultiple()
			}
		})
	}

	this.resetFields = function () {
		var userGroup = this
		_.each(this.fields, function (field) {
			initDataInTextInput(userGroup.prefix + field, '')
		})
		_.each(this.allPermissions, function (permission) {
			initDataInBoolean(permission.code, false)
		})
	}

	this.setUserGroupPermissions = function () {
		if (this.rolePermissions == null) {
			$.ajax({
				type: 'POST',
				url: window.urlContext + 'role/permission/get',
				data: { id: this.roleId },
				context: this,
				async: false,

				success: function (data) {
					this.rolePermissions = data
				}
			})
		}

		_.each(this.rolePermissions, function (permission) {
			initDataInBoolean(permission.code, true)
		})
	}

	this.getUserGroupInformation = function () {
		var userGroup = this
		var userGroupInformation = {}
		this.fields.splice(this.fields.length - 1, 1)

		if (this.action == 'edit') {
			userGroupInformation.id = this.roleId
		}
		userGroupInformation.companyId = this.global ? null : this.companyId

		_.each(this.fields, function (field) {
			userGroupInformation[field] = getDataFromTextInput(userGroup.prefix + field)
		})

		return userGroupInformation
	}

	this.getUserGroupPermissions = function () {
		var userGroupPermissions = []

		$('#user-role_permissions').find('.checkbox').each(function (index, checkbox) {
			if (getDataFromBoolean($(checkbox).attr('id'))) {
				userGroupPermissions.push($(checkbox).attr('data-id'));
			}
		});

		return userGroupPermissions;
	};
}
